import React from 'react';
import PropTypes from 'prop-types';
import { Col, Layout, Row } from 'antd';
import TriptychLayoutAppend from './TriptychLayoutAppend';
import TriptychLayoutPrepend from './TriptychLayoutPreppend';
import TriptychLayoutContent from './TriptychLayoutContent';
import './styles.less';
import useMobileBreakpoint from '../../../hooks/useMobileBreakpoint';
import TriptychLayoutFooter from './TriptychLayoutFooter';

const TriptychLayout = ({
  className,
  children,
  noPrependPadding,
  noContentPadding,
  noAppendPadding,
  hideAppend,
  style,
}) => {
  const [prepend, content, append, footer] = children;

  const isMobile = useMobileBreakpoint();

  const colSizes = {
    lg: 7,
  };

  const contentColSizes = {
    lg: hideAppend ? 14 : 10,
  };

  return (
    <>
      <Layout className={className} style={style}>
        <Row className="triptych__row">
          <Col
            span={24}
            lg={colSizes.lg}
            className={!isMobile ? 'triptych__col--full-height' : undefined}
          >
            <TriptychLayoutPrepend noPadding={noPrependPadding}>{prepend}</TriptychLayoutPrepend>
          </Col>
          <Col
            span={24}
            lg={contentColSizes.lg}
            className={!isMobile ? 'triptych__col--full-height' : undefined}
          >
            <TriptychLayoutContent noPadding={noContentPadding}>{content}</TriptychLayoutContent>
          </Col>
          {footer && isMobile && (
            <Col span={24}>
              <TriptychLayoutFooter>{footer}</TriptychLayoutFooter>
            </Col>
          )}
          {!hideAppend && (
            <Col
              span={24}
              lg={colSizes.lg}
              className={!isMobile ? 'triptych__col--full-height' : undefined}
            >
              <TriptychLayoutAppend noPadding={noAppendPadding}>{append}</TriptychLayoutAppend>
            </Col>
          )}
          {footer && !isMobile && (
            <Col span={24}>
              <TriptychLayoutFooter>{footer}</TriptychLayoutFooter>
            </Col>
          )}
        </Row>
      </Layout>
    </>
  );
};

TriptychLayout.propTypes = {
  className: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.node),
  noPrependPadding: PropTypes.bool,
  noContentPadding: PropTypes.bool,
  noAppendPadding: PropTypes.bool,
  hideAppend: PropTypes.bool,
  style: PropTypes.shape(),
};

TriptychLayout.defaultProps = {
  className: null,
  children: [],
  noPrependPadding: false,
  noContentPadding: false,
  noAppendPadding: false,
  hideAppend: false,
  style: undefined,
};

export { TriptychLayout, TriptychLayoutAppend, TriptychLayoutContent, TriptychLayoutPrepend };
